<template>
  
  <el-submenu v-if="menu.child && menu.child.length >= 1" :index='menu.url'>
    <template slot="title">
      <i :class="menu.icon"></i>
      <span slot="title">{{menu.title}}</span>
    </template>
    <el-menu-item-group >
      <el-menu-item v-for="child in menu.child" :key="child.id" :index='child.url'>{{child.title}}</el-menu-item>
    </el-menu-item-group>
  </el-submenu>
  <el-menu-item v-else :index="menu.url">
    <i :class="menu.icon"></i>
    <span slot="title">{{menu.title}}</span>
  </el-menu-item>
</template>

<script>
  export default {
    name: 'MenuTree',
    props: {
      menu: {
        type: Object,
        required: true
      }
    },
    methods: {
      handleRoute (menu) {
        // 通过菜单URL跳转至指定路由
        this.$router.push(menu.url)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/MenuTree.vue